import { useState, FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from 'utils/supabase'
import styled from 'styled-components'
import { Button, TextField } from '@mui/material'
import toast from 'react-hot-toast'
import logo from 'assets/prb-logo.png'

const defaultValues = {
  email: '',
  password: ''
}

export default function Login() {
  const [credentials, setCredentials] = useState(defaultValues)
  const navigate = useNavigate()

  const handleValueChange = (name: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials(prev => ({ ...prev, [name]: e.target.value }))
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      const { data, error } = await supabase.auth.signInWithPassword(credentials)

      if (data.user) {
        navigate('/admin/articles')
      }

      if (error) {
        toast.error('Błąd logowania')
      }
    } catch (err) {
      toast.error('Błąd logowania')
      console.error(err)
    }
  }

  return (
    <Wrapper>
      <Logo src={logo} alt="PRB Logo" />
      <Form onSubmit={handleSubmit}>
        <TextField
          required
          fullWidth
          value={credentials.email}
          onChange={handleValueChange('email')}
          label='Email'
          variant='outlined'
        />
        <TextField
          required
          type='password'
          fullWidth
          value={credentials.password}
          onChange={handleValueChange('password')}
          label='Hasło'
          variant='outlined'
        />
        <ButtonWrapper>
          <Button variant='contained' type='submit'>
            Zaloguj
          </Button>
        </ButtonWrapper>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 400px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Logo = styled.img`
  width: 200px;
  margin-bottom: 40px;
` 